import React, { PropTypes } from 'react';
import * as B from 'react-bootstrap';

const bootstrapField = field => (
  <B.FormGroup validationState={field.meta.touched ? (
    field.meta.error ? 'error' : 'success'
  ) : undefined}>
    <B.ControlLabel>{field.label}</B.ControlLabel>
    <B.FormControl {...field.input}
      autoFocus={field.autoFocus}
      type={field.type || 'text'}
    />
    <B.FormControl.Feedback />
    {
      field.meta.touched && field.meta.error &&
     <B.HelpBlock>{field.meta.error}</B.HelpBlock>
    }
  </B.FormGroup>
);

bootstrapField.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    autoFocus: PropTypes.bool
  })
};

export default bootstrapField;



// WEBPACK FOOTER //
// ./components/lib/bootstrapfield/index.js